import React from 'react';
import DashboardLayout from '../../components/dashboard/DashboardLayout';
import ExpenseManagement from '../../components/dashboard/ExpenseManagement';

const ExpenseManagementPage = () => {
    return (
        <DashboardLayout>
            <ExpenseManagement />
        </DashboardLayout>
    );
};

export default ExpenseManagementPage;
